/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { getUserLanguageCode } from 'js/lib/language';
import { languageTagToLocalName } from 'js/lib/languageLocalized';

import { useTracker } from '@coursera/event-pulse/react';

import MobileButton from 'bundles/composable-page-header/components/mobile-menu-items/MobileButton';
import { MOBILE_MAIN_IDENTIFIER } from 'bundles/composable-page-header/constants';
import { useMobileToSubPage } from 'bundles/composable-page-header/contexts/MobileNavigationContext';
import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';

import _t from 'i18n!nls/composable-page-header';

const styles = {
  labelPrefix: css`
    &::after {
      content: ' ';
    }
  `,
};

const LanguageTranslationMenuItem = () => {
  const toSubPage = useMobileToSubPage();
  const track = useTracker();
  const isOrgScoped = useIsOrgScopedHome();

  const locale = getUserLanguageCode();
  if (!locale) return null;

  const labelPrefix = isOrgScoped ? _t('Language:') : _t('Preferred language:');

  return (
    <MobileButton
      label={
        <>
          <span css={styles.labelPrefix}>{labelPrefix}</span>
          {languageTagToLocalName(locale)}
        </>
      }
      name="language"
      trackingName="mobile_header_language_button"
      onButtonClick={() => {
        track('open_navigation_menu', {
          navigationType: 'language',
        });
        toSubPage?.(MOBILE_MAIN_IDENTIFIER.LANGUAGE_MENU);
      }}
    />
  );
};

export default LanguageTranslationMenuItem;
